// the app's theme
export const theme = {
  // COLORS
  colorPrimary: '#E35A2F', // 'rgba(46,150,211,1)',
  colorDark1: '#1896FD', // '#14161b',
  colorDark2: '#fbfcfc', // '#2e303b',
  nav: {
    height: '42px',
  },
  color: {
    background: '#fbfcfc',
    normal: '#fffdf6',
    primary: '#E35A2F',
    navy: '#4f5d75',
    darkNavy: '#2d3142',
    navy1: '#4f5d75',
    primaryBlack: '#262626',
    primaryHover: 'rgba(255, 148, 100, 0.2)',
    bodyBackground: '#FBFCFC',
    success: '#2ecc71',
    error: '##e74c3c',
  },
  appWidth: '1100px',
  // DEFAULTS
  borderRadius: 10,
  margin: 10,
  padding: 20,
  fontFamily: "'Nunito', sans-serif",
  // OLD
};

export default theme;



// WEBPACK FOOTER //
// ./src/lib/theme/theme.js